import { combineReducers } from "redux";
import { apiProduct } from "./apiProduct";
import { application } from "./application";
import { apiDocumentation } from "./apiDocumentation";
import { applicationForm } from "./applicationForm";
import { general } from "./general";
import { forum } from "./forum";
import { cookies } from "./cookies";
import { breadcrumb } from "./breadcrumb";
import { terminal } from "./terminal";
import { terminalCommands } from "./terminalCommands";
import { tryout } from "./tryout";
import { dateTime } from "./dateTime";
import { userQuestionaire } from "./questionaire";
import { gettingStarted } from "./gettingStarted";
import { apiErrors } from "./apiErrors";
import { reducer as form } from "redux-form";
import { LOGOUT } from "../authentication/actions/types";
import { analytics } from "./analytics";
import { organizationFormReducer } from "./organizationFormReducer";
import { organizationReducer } from "./organizationReducer";
import { contact } from "./contact";
import { applicationUser } from "../authentication/reducers";
import { produce } from "immer";
import headerPin from "./headerPin";
import pageTitle from "./pageTitle";
import supportTicketReducer from "./supportTicketReducer";

const createReducer =
  ({ initialState, handlers }) =>
  (state = initialState, action) => {
    // Use Immer for immutable updates
    if (handlers.hasOwnProperty(action.type)) {
      return produce(state, (draft) => {
        // Call the handler with the draft state
        const handler = handlers[action.type];
        const result = handler(draft, action);
        // If handler returns a value, use it as the new state
        if (result !== undefined) {
          return result;
        }
      });
    }
    return state;
  };

const importedReducers = {
  analytics,
  apiProduct,
  application,
  applicationUser,
  contact,
  apiDocumentation,
  applicationForm,
  general,
  forum,
  cookies,
  terminal,
  tryout,
  dateTime,
  terminalCommands,
  breadcrumb,
  organizationReducer,
  organizationFormReducer,
  gettingStarted,
  userQuestionaire,
  apiErrors,
};

const appReducers = combineReducers(
  Object.keys(importedReducers).reduce(
    (result, key) => ({
      ...result,
      [key]: createReducer(importedReducers[key]),
    }),
    {
      form,
      headerPin,
      pageTitle,
      supportTicket: supportTicketReducer,
    }
  )
);

export const reducers = (state, action) => {
  if (action.type === LOGOUT) {
    Object.keys(state).forEach((key) => {
      if (
        ![
          "cookies",
          "general",
          "faqs",
          "faqsCategories",
          "apiProduct",
          "forum",
          "gettingStarted",
        ].includes(key)
      ) {
        state[key] = undefined;
      }
    });
  }
  return appReducers(state, action);
};

export function overrideReducer(red1, red2) {
  return {
    initialState: {
      ...red1.initialState,
      ...red2.initialState,
    },
    handlers: {
      ...red1.handlers,
      ...red2.handlers,
    },
  };
}
